import Swiper from 'swiper';
import Component from "../classes/Component";
import {$events} from "../helpers/events";

const sliderSelector = '.js-slider-group'
const prevButtonSelector = '.js-prev-slider-button'
const nextButtonSelector = '.js-next-slider-button'

export default function () {

    return new Component({
        name: 'cardSlider',
        requiredTargets: sliderSelector,
        onInit() {
            const swiper = new Swiper(sliderSelector, {
                navigation: {
                    nextEl: nextButtonSelector,
                    prevEl: prevButtonSelector,
                },

                breakpoints: {
                    1200: {
                        slidesPerView: '4',
                        spaceBetween: 30
                    },

                    992: {
                        slidesPerView: '3',
                        spaceBetween: 20
                    },

                    767: {
                        slidesPerView: '2',
                        spaceBetween: 120
                    },
                }
            })

            $events.delegate.on('click', nextButtonSelector, () => {
                swiper.slideNext()
            })

            $events.delegate.on('click', prevButtonSelector, () => {
                swiper.slidePrev()
            })
        },
        onDestroy() {
            console.log('carousel')
        },
    })

}